import React from 'react';

export default function BrandMark({ className = "w-8 h-8", color = "#00F0FF" }) {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="20" height="20" rx="4" stroke={color} strokeWidth="1.5" strokeOpacity="0.3" />
      <path d="M6 12H7M10 12H11M14 12H15M18 12H19" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M8 8V16M12 5V19M16 8V16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeOpacity="0.8" />
      <circle cx="12" cy="12" r="1.5" fill={color} className="animate-pulse" />
    </svg>
  );
}